import { render, staticRenderFns } from "./ModalHistoryKasVirtual.vue?vue&type=template&id=fe9b3ae8&scoped=true&"
import script from "./ModalHistoryKasVirtual.vue?vue&type=script&lang=js&"
export * from "./ModalHistoryKasVirtual.vue?vue&type=script&lang=js&"
import style0 from "./ModalHistoryKasVirtual.vue?vue&type=style&index=0&id=fe9b3ae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9b3ae8",
  null
  
)

export default component.exports